module.exports = __webpack_public_path__ + "assets/img/3-1.0b0b2df0.png";